import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Vuex)

// var URL = 'http://localhost:5001/'
// var URL = 'http://192.168.1.8:5028/'
var URL = 'https://server-egov.konaweselatankab.go.id/'

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL,

      URL_simpeg_biodata : URL+'api/v1/simpeg_biodata/',
      URL_simpeg_unit_kerja: URL+'api/v1/simpeg_unit_kerja/',
      URL_simpeg_instansi : URL+'api/v1/simpeg_instansi/',

      URL_DM_REGISTER : URL+'api/v1/lppd_dm_registrasi/',
      URL_DM_MENU : URL+'api/v1/lppd_dm_menuList/',
      URL_DM_KLP_USERS : URL+'api/v1/lppd_dm_kelompokUsers/',
      URL_Beranda : URL + 'api/v1/lppd_server_beranda/',
      URL_OUTPUT : URL + 'api/v1/lppd_server_output/',
      URL_OUT_COME : URL + 'api/v1/lppd_server_out_come/',
      URL_OUTCOME : URL + 'api/v1/lppd_server_outcome/',
      URL_INSPEKTORAT : URL + 'api/v1/lppd_server_inspektorat/',
      URL_BKAD : URL + 'api/v1/lppd_server_bkad/',
      URL_DIKBUD : URL + 'api/v1/lppd_server_dikbud/',
      URL_SATPOL : URL + 'api/v1/lppd_server_satpol/',
      URL_BPBD : URL + 'api/v1/lppd_server_bpbd/',
      URL_DINSOS : URL + 'api/v1/lppd_server_dinsos/',
      URL_DINKES : URL + 'api/v1/lppd_server_dinkes/',
      URL_DAMKAR : URL + 'api/v1/lppd_server_damkar/',
      URL_DISNAKER : URL + 'api/v1/lppd_server_disnaker/',
      URL_DPPPA : URL + 'api/v1/lppd_server_dpppa/',
      URL_KETAPANG : URL + 'api/v1/lppd_server_ketapang/',
      URL_DLH : URL + 'api/v1/lppd_server_dlh/',
      URL_DISHUB : URL + 'api/v1/lppd_server_dishub/',
      URL_DPMD : URL + 'api/v1/lppd_server_dpmd/',
      URL_DPMPTSP : URL + 'api/v1/lppd_server_dpmptsp/',
      URL_DINKOP : URL + 'api/v1/lppd_server_dinkop/',
      URL_DPAD : URL + 'api/v1/lppd_server_dpad/',
      URL_DISPORA : URL + 'api/v1/lppd_server_dispora/',
      URL_DPPKB : URL + 'api/v1/lppd_server_dppkb/',
      URL_DISDUKCAPIL : URL + 'api/v1/lppd_server_disdukcapil/',
      URL_DISKOMINFO : URL + 'api/v1/lppd_server_diskominfo/',
      URL_DPUTR : URL + 'api/v1/lppd_server_dputr/',
      URL_BKPSDM : URL + 'api/v1/lppd_server_bkpsdm/',
      URL_DPKP : URL + 'api/v1/lppd_server_dpkp/',
      URL_DISPAR : URL + 'api/v1/lppd_server_dispar/',
      URL_DTPHP : URL + 'api/v1/lppd_server_dtphp/',
      URL_DIKNAN : URL + 'api/v1/lppd_server_diknan/',
      URL_DISNAKKESWAN : URL + 'api/v1/lppd_server_disnakkeswan/',
      URL_UKPBJ : URL + 'api/v1/lppd_server_ukpbj/',
      URL_DISPERINDAG : URL + 'api/v1/lppd_server_disperindag/',
      URL_TOTAL : URL + 'api/v1/lppd_server_total/',
      URL_INDIKATOR : URL + 'api/v1/lppd_server_indikator/',
      URL_KOLOM : URL + 'api/v1/lppd_server_kolom/',
      URL_Unit : URL + 'api/v1/lppd_server_unit/',
      URL_Tahun : URL + 'api/v1/lppd_server_tahun/',
      URL_Kecamatan : URL + 'api/v1/lppd_server_kecamatan/',
    },

    // ====================================== CONTOH AUTOCOMPLETE ====================================
    list_contoh_autocomplete : [],
    list_unit_kerja: [],
    list_instansi: [],
    // ====================================== CONTOH AUTOCOMPLETE ====================================

    list_menu : null,
    aksesMenu : {},

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    type : [
      {id : 0, uraian : 'Single Menu'},
      {id : 1, uraian : 'Multy Menu'}
    ],

    
  },
  mutations: {
    listJeniskategorilokasi(state){

      fetch(state.url.URL_MasterKategoriLokasi, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          state.list_MasterKategoriLokasi = res_data;
      });

    },

    listApelJenis(state){

      fetch(state.url.URL_apelJenis, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data)
          state.list_ApleJenis = res_data;
      });

    },

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'purple-4',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
